import React, { useEffect, useState } from 'react';
import './Toast.scss';

const Toast = ({
    id,
    type = 'info',
    title,
    message,
    duration = 5000,
    onClose,
    position = 'bottom-right'
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isLeaving, setIsLeaving] = useState(false);

    useEffect(() => {
        // Trigger entrance animation
        const timer = setTimeout(() => setIsVisible(true), 10);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                handleClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration]);

    const handleClose = () => {
        setIsLeaving(true);
        setTimeout(() => {
            onClose(id);
        }, 300); // Match animation duration
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return '✓';
            case 'error':
                return '✕';
            case 'warning':
                return '⚠';
            case 'info':
            default:
                return 'ℹ';
        }
    };

    return (
        <div
            className={`toast toast--${type} toast--${position} ${
                isVisible && !isLeaving ? 'toast--visible' : ''
            } ${isLeaving ? 'toast--leaving' : ''}`}
        >
            <div className="toast__icon">
                {getIcon()}
            </div>
            <div className="toast__content">
                {title && <div className="toast__title">{title}</div>}
                <div className="toast__message">{message}</div>
            </div>
            <button
                className="toast__close"
                onClick={handleClose}
                aria-label="Close notification"
            >
                ×
            </button>
        </div>
    );
};

export default Toast;